import clsx from 'clsx'
import React from 'react'

import { RenderButton } from '../../atoms/Button/RenderButton'
import Headings from '../../atoms/Heading'
import Image from '../../atoms/Image'
import Paragraph from '../../atoms/Paragraph'
import Arrow from '../../atoms/icons/arrow/Arrow'
import Link, { LinkProps } from '../../atoms/link/Link'
import { mapCombinedLink } from '../../utils/mappings/general'
import {
  backgroundColorClassMap,
  BackgroundColour,
  LinkStyle,
  primaryLinkVariants,
  secondaryLinkVariants,
  textColorClassMap,
} from './FeatureBlockWithImage.styles'
import {  launchVideoAsk } from '../../../utils/videoAsk'

// TODO: update the 'any' type here
interface FeatureBlockWithImageProps {
  variant: 'image-left' | 'image-right'
  backgroundColor: BackgroundColour
  headline?: string
  bodyText: any
  columnImage: any
  firstLinkStyle: LinkStyle
  firstLinkEntry: any
  secondLinkStyle: LinkStyle
  secondLinkEntry: any
  thirdLinkStyle: LinkStyle
  thirdLinkEntry: any
  /** @deprecated This will be removed in the future release once the content is migrated. Please do not use this prop */
  buttonComponent: any
}

interface CtaProps {
  style: LinkStyle
  link: any
}

// icon check
const isIconIncluded = (str: string) => {
  return str && str.toLowerCase().includes('icon')
}

export const FeatureBlockWithImage = ({
  variant,
  backgroundColor = 'Purple',
  headline,
  bodyText,
  columnImage,
  firstLinkStyle,
  firstLinkEntry,
  secondLinkStyle,
  secondLinkEntry,
  thirdLinkStyle,
  thirdLinkEntry,
  buttonComponent,
}: FeatureBlockWithImageProps): JSX.Element => {
  const colorVariant = backgroundColor.toLowerCase()
  const bgColor = backgroundColorClassMap[colorVariant]
  const textColor = textColorClassMap[colorVariant]
  const links: CtaProps[] = [
    { style: firstLinkStyle, link: firstLinkEntry },
    { style: secondLinkStyle, link: secondLinkEntry },
    { style: thirdLinkStyle, link: thirdLinkEntry },
  ]

  return (
    <div className="layoutSpacing">
      <div data-testid="FeatureBlock" className={`layout sectionBottomSpacing w-100`}>
        <div
          data-testid="featureImageLeft"
          className={clsx(
            'flex items-center overflow-hidden rounded-2xl border border-neutral-50 xl:flex-row',
            bgColor,
            variant === 'image-left' ? 'flex-col' : 'flex-col-reverse xl:!flex-row-reverse',
          )}
        >
          {!isIconIncluded(columnImage?.fields?.title) && !isIconIncluded(columnImage?.fields?.description) ? (
            <div
              data-testid="image"
              aria-label={columnImage?.fields?.title}
              className="aspect-video flex-1 self-stretch bg-cover bg-no-repeat"
              style={{ backgroundImage: `url(${columnImage.fields?.file?.url})` }}
            ></div>
          ) : (
            <div className="pl-32 pt-32 lg:pl-48">
              <Image imageUrl={columnImage.fields?.file?.url} altText={columnImage.fields?.title} width="56" />
            </div>
          )}
          <div className="flex-1">
            <div className="p-32 lg:p-48">
              <Headings content={headline} variant="H3" classes={`${textColor}`} />
              <Paragraph content={bodyText} classes={`${textColor}`} />
              <div className="flex flex-col flex-wrap gap-16 pt-24" data-testid="featureButtonComponent">
                {buttonComponent?.map((item, index) => (
                  <div key={`${item?.fields?.ctaButtonVariety}-${index}`}>
                    <RenderButton item={item} />
                  </div>
                ))}
                {links.map(({ style, link }) => {
                  if (!link || !link.fields) return <></>

                  const linkContent = mapCombinedLink(link.fields)
                  let linkStyle: LinkProps['intent'] | undefined
                  switch (style) {
                    case 'Alternate':
                      linkStyle = colorVariant === 'teal' ? 'teal' : 'orange'
                      break
                    case 'Secondary':
                      linkStyle = secondaryLinkVariants[colorVariant]
                      break
                    default:
                      linkStyle = primaryLinkVariants[colorVariant]
                  }
                

const popupProvider =  link?.fields?.popupProvider

const shouldLaunchVideoAsk =  popupProvider === 'ESSSuper Digital Assistant (VideoAsk)'

if (shouldLaunchVideoAsk) {

return(
    <Link
      key={linkContent.title}
      intent={linkStyle}
      href={window.location.href}
      className="inline-flex w-fit"
       onClick={(e) => {
        e.preventDefault()
        launchVideoAsk(linkContent.href)
      }}
    >
      {linkContent.title}
<Arrow className="ml-16 h-24 w-24" />
                    </Link>
)
}     
                  return (
                    <Link
                      key={linkContent.title}
                      intent={linkStyle}
                      href={
                        linkContent.href && linkContent.href !== '/undefined' ? linkContent.href : window.location.href
                      }
                      openInNewTab={linkContent.openLinkInNewTab}
                      className="inline-flex w-fit"
                    >
                      {linkContent.title} <Arrow className="ml-16 h-24 w-24" />
                    </Link>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeatureBlockWithImage
